<div class="rx-profile-content t-scrollbar">
  <div class="opt-container">
    <input-wrap label="{{ 'translate.mng.technician' | translate }}">
      <p-select
        class="t-input--colored"
        [options]="techniciansList"
        [(ngModel)]="technician"
        [placeholder]="'translate.general.choose' | translate"
        [optionLabel]="'label'"
        appendTo="body"
      ></p-select>
      <clear-multi *ngIf="technician" (click)="clearPG()"></clear-multi>
    </input-wrap>

    <input-wrap *ngIf="technician" label="ליווי אישי">
      <checkbox-wrap class="checkbox">
        <input type="checkbox" [(ngModel)]="pgSw" />
      </checkbox-wrap>
    </input-wrap>

    <input-wrap *ngIf="technician" label="השהיית ליווי אישי עד">
      <p-datepicker
        class="t-input--colored p-append-top"
        dateFormat="dd/mm/yy"
        [(ngModel)]="pgSnoozeDate"
        readonlyInput="readonlyInput"
        [locale]="calLocale"
        showButtonBar="true"
        placeholder="{{ 'translate.general.choose' | translate }}"
        appendTo="body"
      ></p-datepicker>
    </input-wrap>
  </div>
</div>
